import {useSelector} from 'react-redux';

import type {Entitlement} from '../types';

export function useEntitlement(): Entitlement {
    return useSelector((ctx: any) => ctx.entitlement.name);
}
